<template>
    <div v-if="$store.state.isModalOpenTwo" class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-md modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                          <h1 class="mb-0">Attendance Approval</h1>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                  <div class="row mx-2">
                    <p class="pt-1">Name: {{ attendance.name || '' }}</p>
                    <p class="pt-1">Date: {{ attendance.calendar_date || '' }}</p>
                    <p class="pt-1">In Time: {{ attendance.in_time_format || '' }}</p>
                    <p class="pt-1">Out Time: {{ attendance.out_time_format || '' }}</p>

                    <div class="col-12">
                      <label class="align-middle">Approval Status</label>
                      <v-select
                          placeholder="Select Status"
                          v-model="approvalStatus"
                          :options="approvalStatusList"
                          :reduce="name => name.value"
                          label="name"
                      />
                    </div>

                    <div class="col-12">
                      <div class="mb-1">
                        <label class="form-label" for="mobileNo">Approval Remarks </label>
                        <input
                            class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                            tabindex="1"
                            type="text"
                            placeholder=""
                            v-model="remarks"
                        >
                      </div>
                    </div>

                    <div class="col-6 text-center mb-2 mt-2">
                      <button :disabled="loading" @click="submit" type="button" class="btn btn-primary full-width me-1 waves-effect waves-float waves-light">
                        <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        Submit
                      </button>
                    </div>
                    </div>
                 </div>
            </div>
        </div>
        <Loader v-if="loader"/>

    </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import {computed, inject, onMounted, ref, watch} from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";

const props = defineProps({
  attendanceData:{
      type:Object,
      default:{}
    },
});

const attendance = computed(() => props.attendanceData || {});
const emit = defineEmits(['getAttendanceList']);
const $store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const approvalStatus = ref('');
const remarks = ref('');
const approvalStatusList = ref([]);
const loader = ref(false);
const showError = inject('showError');
const showSuccess = inject('showSuccess');

const {
  fetchTypes,
  updateAttendanceApproval,
} = handleHrPayroll()

const submit = async() => {
    const query = getQuery();
    loading.value = true;
    await storeData(query)
}

const storeData = async (query) => {
  let attendanceData = {};
  attendanceData.status = approvalStatus.value;
  attendanceData.approval_remarks = remarks.value;
  attendanceData.attendance_id = props.attendanceData ? props.attendanceData.id : null;
  await updateAttendanceApproval(attendanceData, query).then((res) => {
    loading.value = false
    if (!res.status) return showError(res.message)
    emit("getAttendanceList");
    onClickClose();
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getTypes = async () => {
  let query = getQuery();
  await fetchTypes(query).then(res => {
    if (!res.status){
      approvalStatusList.value = [];
      return
    }

    if (res.data && res.data.attendanceApprovalStatus) {
      approvalStatusList.value = res.data.attendanceApprovalStatus;
    }

  }).catch(err => {
    console.log(err)
  })
}

const onClickClose = () => {
    $store.state.isModalOpenTwo = false;
}

function getQuery() {
  return `?company_id=${$route.params.companyId}`;
}

watch(() => props.attendanceData, (newVal) => {
  if (newVal){
    approvalStatus.value = newVal.status
  }
}, { immediate: true })

onMounted(() => {
  getTypes()
})
</script>
